import * as React from 'react'
import { FunctionComponent } from 'react'
import NoteOverview from './NoteOverview'
import { noteBaseUrl } from '../Notes'
import { getDataEmptyState } from '../../context/AxiosContext'

const GlobalNoteOverview: FunctionComponent = () => <NoteOverview baseUrl={noteBaseUrl} notes={getDataEmptyState()} />

export default GlobalNoteOverview
